import type { Processo } from '@/api/client';
import type { SmartSearchFields } from '@/lib/search/smartSearch';

/**
 * O que a busca do Acervo enxerga em cada linha: o que a linha mostra (número,
 * partes, tribunal, classe, a etiqueta "Importado") e o assunto. As partes vão
 * TODAS, não só o resumo "Fulano x Beltrano e outros (2)" — quem procura pelo
 * terceiro réu também precisa achar. Campos separados por quebra de linha para
 * uma frase entre aspas não casar emendando dois campos.
 */
export const ACERVO_SEARCH_FIELDS: SmartSearchFields<Processo> = {
  text: (p) =>
    [
      p.numero,
      p.tribunal,
      p.classe,
      p.assunto,
      ...(p.partes_resumo ?? []).map((parte) => parte.nome),
      p.origem === 'DATALAKE' ? 'Importado' : null,
      p.origem === 'FAMILIA' ? 'Relacionado' : null,
    ]
      .filter(Boolean)
      .join('\n'),
  processNumber: (p) => p.numero,
};
